import { Interval } from 'luxon';

import { DateRangeType } from '../../types/baseTypes/DateRangeType';
import parseDateTime from './parseDateTime';

/**
 * @deprecated Use doDateRangesOverlap from '@lane-next/async-timing' instead.
 * This function will be removed in a future version.
 */
export default function doDateRangesOverlap(
  rangeA: DateRangeType,
  rangeB: DateRangeType
): boolean {
  try {
    const intervalA = Interval.fromDateTimes(
      parseDateTime(rangeA.startDate)!,
      parseDateTime(rangeA.endDate)!
    );
    const intervalB = Interval.fromDateTimes(
      parseDateTime(rangeB.startDate)!,
      parseDateTime(rangeB.endDate)!
    );

    return intervalA.overlaps(intervalB);
    // FIXME: log error for datadog, missing stack trace
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
}
